import { API_CODE } from "../../../../../controller/api/constants"
import { getApi, postApi, uploadApi } from "../../../../../controller/api/get"
import { calculateTotalPage, calculatePageToSkipTake } from "../../../../../helper/helper";

export const getSummary = async (cookie, filter) => {
  const requestData = {
    from: filter.from,
    to: filter.to,
    passengerIdentify: filter.identify,
    status: filter.status && filter.status.length > 0 ? parseInt(filter.status) : undefined,
    routeId: filter.routeId && filter.routeId.length > 0 ? filter.routeId : undefined,
    id: filter.id,
    cartId: filter.cartId,
  }

  const response = await getApi(cookie, API_CODE.GET_TICKET_SUMMARY, requestData)

  if (response) {
    return {
      count: response.count,
      value: response.value
    }
  }
  return undefined
}

export const getList = async (cookie, filter, page) => {
  const [skip, take] = calculatePageToSkipTake(page)
  const requestData = {
    from: filter.from,
    to: filter.to,
    passengerIdentify: filter.identify,
    status: filter.status && filter.status.length > 0 ? parseInt(filter.status) : undefined,
    routeId: filter.routeId && filter.routeId.length > 0 ? filter.routeId : undefined,
    id: filter.id,
    cartId: filter.cartId,
    skip: skip,
    take: take,
  }
  const response = await getApi(cookie, API_CODE.GET_TICKET, requestData)

  if (response) {
    return {
      list: response.list,
      total: response.total,
      totalPage: calculateTotalPage(response.total)
    }
  }
  return undefined
}

export const getListRoutes = async (cookie) => {
  const response = await getApi(cookie, API_CODE.GET_ROUTE, {})

  if (response) {
    return response
  }
  return []
}

export const getListBoats = async (cookie) => {
  const response = await getApi(cookie, API_CODE.GET_BOAT, {})

  if (response) {
    return response
  }
  return []
}

export const update = async (cookie, id, action, data) => {
  const requestData = {
    id: id,
    action: action,
    data: data
  }
  const response = await postApi(cookie, API_CODE.POST_UPDATE_TICKET, requestData)

  return response
}

export const upload = async (name, type, ticket) => {
  const response = await uploadApi(ticket, name, type)

  return response
}